/** Copy of the purchaseOrders page (Operations), ported from VentaHub. */
export const purchaseOrders = {
  title: 'Purchase orders',
  description: 'Orders retailers have placed with us, to ship from one of our warehouses.',
  newOrder: 'New purchase order',
  newOrderHint: 'Choose a warehouse and a retailer in the filters first.',
  uploadSheet: 'Upload sheet',
  empty: 'No purchase orders match',
  emptyHint: 'Widen the filters, or create a purchase order.',
  filtered: 'Filters are applied.',
  filters: {
    code: 'PO code',
    sku: 'SKU code',
    warehouse: 'Warehouse',
    retailer: 'Retailer',
    created: 'Created',
    sort: 'Sort by',
    all: 'All',
    clear: 'Clear filters',
  },
  sorts: {
    newest: 'Newest first',
    oldest: 'Oldest first',
    poDateNewest: 'PO date, newest',
    poDateOldest: 'PO date, oldest',
    codeAsc: 'Code, A to Z',
    codeDesc: 'Code, Z to A',
    amountDesc: 'Amount, high to low',
    amountAsc: 'Amount, low to high',
  },
  columns: {
    code: 'PO code',
    retailer: 'Retailer',
    warehouse: 'Warehouse',
    poDate: 'PO date',
    units: 'Units',
    amount: 'Amount',
    lines: 'Lines',
    appointment: 'Appointment',
    created: 'Created',
    actions: 'Actions',
  },
  open: 'Open PO {{code}}',
  delete: 'Delete PO {{code}}',
  allot: {
    action: 'Allot boxes',
    show: 'Show allotment',
    hide: 'Hide allotment',
    heading: 'Allotment',
    none: 'No boxes are allotted to this PO.',
    title: 'Allot boxes to {{code}}',
    hint: 'List every box that should be allotted: boxes allotted now and left out go back on the shelf. Boxes must be on the shelf in this PO’s warehouse.',
    codes: 'Box codes (one per line, or separated by commas)',
    count_one: '{{count}} box',
    count_other: '{{count}} boxes',
    releasing: 'releasing {{codes}}',
    save: 'Save allotment',
    useSheet: 'Use a sheet instead',
    sheetTitle: 'Allot boxes to {{code}} from a sheet',
    sheetHint:
      'The sheet is the whole set, like the list: boxes allotted now and left out go back on the shelf. It goes for approval, and the boxes are allotted once it is accepted.',
    saved_one: '{{count}} box allotted',
    saved_other: '{{count}} boxes allotted',
    columns: {
      ordered: 'Ordered',
      allotted: 'Allotted',
      blocked: 'Blocked',
      invoiced: 'Invoiced',
      open: 'Still open',
    },
  },
  merge: {
    needCodes: 'List at least one PO code.',
    action: 'Merge POs',
    title: 'Merge into {{code}}',
    hint: 'Their lines are added to this PO and they are deleted. They must be in the same warehouse, for the same retailer and in the same currency, with nothing allotted, blocked, invoiced or on a vendor order yet.',
    codes: 'PO codes to merge in',
    save: 'Merge',
    done_one: '{{count}} PO merged into {{code}}',
    done_other: '{{count}} POs merged into {{code}}',
  },
  detail: {
    close: 'Close',
    retailer: 'Retailer',
    warehouse: 'Warehouse',
    poDate: 'PO date',
    validTill: 'Valid until',
    appointment: 'Appointment',
    units: 'Units',
    amount: 'Amount',
    comment: 'Comment',
    lines: 'Lines',
    noLines: 'This purchase order has no lines.',
    editLines: 'Edit lines',
    uploadLines: 'Upload lines',
    downloadLines: 'Download lines',
    setAppointment: 'Set appointment',
    checkStock: 'Check stock',
    hideStock: 'Hide stock check',
    stock: 'Stock availability',
    short: 'Short',
    covered: 'Covered',
  },
  lineColumns: {
    sku: 'SKU',
    retailerSku: 'Retailer SKU',
    ordered: 'Ordered',
    confirmed: 'Confirmed',
    committed: 'Committed',
    price: 'Price',
    available: 'Available',
    status: 'Status',
  },
  form: {
    createTitle: 'New purchase order',
    createDescription: 'Lines are matched to your SKUs by the retailer’s own code.',
    linesTitle: 'Edit lines of {{code}}',
    linesDescription: 'Replaces every line. Quantities cannot go below what is already allotted.',
    warehouse: 'Warehouse',
    retailer: 'Retailer',
    choose: 'Choose…',
    code: 'PO code',
    currency: 'Currency',
    store: 'Store ID',
    storeHint: 'Only needed when the retailer buys through more than one store.',
    comment: 'Comment',
    lines: 'Lines',
    lineCode: 'Retailer SKU, line {{n}}',
    lineQuantity: 'Quantity, line {{n}}',
    linePrice: 'Price, line {{n}}',
    lineHeaderCode: 'Retailer SKU',
    lineHeaderQuantity: 'Quantity',
    lineHeaderPrice: 'Price',
    addLine: 'Add a line',
    removeLine: 'Remove line {{n}}',
    check: 'Check',
    checking: 'Checking…',
    save: 'Save',
    create: 'Create',
    saving: 'Saving…',
    checkedOk: 'Looks good: {{units}} units across the lines.',
    problems: 'Fix these first',
    downloadProblems: 'Download problems',
    bulkLines: {
      template: 'Download Template',
      upload: 'Upload Details from File',
      cannotRead: 'Could not read that file.',
      empty: 'No Retailer SKU rows found in the file.',
      loaded_one: 'Loaded {{count}} item from file.',
      loaded_other: 'Loaded {{count}} items from file.',
    },
    row: 'Line {{n}}',
    codeRequired: 'Enter the PO code.',
    refRequired: 'Enter the SKU.',
    quantityInvalid: 'Quantity must be a whole number of one or more.',
    priceInvalid: 'Price must be a number of zero or more.',
    currencyInvalid: 'Use a three-letter currency code.',
    chooseWarehouse: 'Choose a warehouse.',
    chooseRetailer: 'Choose a retailer.',
    created: 'Purchase order {{code}} created.',
    linesSaved: 'Lines saved.',
  },
  appointment: {
    needDate: 'Choose the appointment date.',
    title: 'Delivery appointment',
    description: 'The date the retailer will receive the delivery.',
    date: 'Appointment date',
    save: 'Save',
    clear: 'Clear',
    saved: 'Appointment saved.',
    cleared: 'Appointment cleared.',
  },
  remove: {
    title: 'Delete PO {{code}}?',
    description:
      'It will disappear from the list. This is refused while stock, an invoice or a vendor order refers to it.',
    cancel: 'Cancel',
    confirm: 'Delete',
    deleting: 'Deleting…',
    deleted: 'Purchase order {{code}} deleted.',
  },
  upload: {
    bulkTitle: 'Upload purchase orders',
    bulkDescription:
      'One row per line item; rows with the same PO code are one purchase order, and a PO code the warehouse already has is left as it is. The sheet goes for approval, and the purchase orders are created once it is accepted.',
    linesTitle: 'Upload lines for {{code}}',
    linesDescription:
      'The sheet is every line of this purchase order: lines it leaves out are removed. It goes for approval, and the lines change once it is accepted.',
    warehouseStep: 'Ship from',
    warehouseHint: 'Every purchase order on the sheet ships from this warehouse.',
    warehouse: 'Ship from warehouse',
  },
} as const
